import axios from "@/utils/axiosHelper";

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios(
    { url: "/sword/report/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 分享奖励
export const shareAPI = (params) => {
  return axios(
    { url: "/sword/report/share", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 获取仙盟数据
export const getTeamAPI = (params) => {
  return axios(
    { url: "/sword/report/team", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 注销
export const onLogoutAPI = (params) => {
  return axios(
    { url: "/game/my/disable", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 渠道登陆
export const LoginByHjwqChannelAPI = (data) => {
  return axios({ url: "/sword/report/login", method: "POST", data });
};



// WEBPACK FOOTER //
// ./src/pages/hjwq/anniversary/api.js